import FileUploader from './file-uploader';

export default FileUploader;
